import croppedLogo from "../../assets/logo (1).png";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export const processHtmlToPdf = ({
  nodeId,
  header,
  title,
  footer,
  filename,
  orientation,
  pageType,
}) => {
  const htmlNode = document.getElementById(nodeId);
  if (pageType === "canvas") {
    html2canvas(htmlNode).then(function (canvas) {
      const imgWidth = 208;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      var imgData = canvas.toDataURL("image/jpeg", 0.3);
      var pdf = new jsPDF(orientation, "mm", "a4", true);
      pdf.setFontSize(14);
      pdf.setTextColor(0, 0, 0);
      var img = new Image();
      // college icon
      img.src = `${croppedLogo}`;
      pdf.addImage(img, "JPEG", 5, 5, 15, 15);
      // header just right to the logo
      pdf.text(22, 14, header);
      pdf.setFontSize(10);
      pdf.text(5, 28, title);
      pdf.line(0, 31, 300, 31);
      pdf.addImage(
        imgData,
        "JPEG",
        3,
        35,
        imgWidth,
        imgHeight,
        undefined,
        "FAST"
      );
      pdf.line(0, imgHeight + 40, 300, imgHeight + 40);
      pdf.setFontSize(8);
      pdf.setTextColor(130, 137, 151);
      pdf.text(5, imgHeight + 47, footer);
      pdf.save(`${filename}.pdf`);
    });
  } else if (pageType === "table") {
    var pdf = new jsPDF(orientation, "mm", "a4", true);
        const target = document.getElementById(nodeId);
        pdf.setFontSize(14);
        pdf.setTextColor(0, 0, 0);
        var img = new Image();
        img.src = `${croppedLogo}`;
        pdf.addImage(img, "JPEG", 5, 5, 15, 15);
        pdf.text(22, 14, header);
        pdf.setFontSize(10);
        pdf.text(5, 28, title);
        pdf.line(0, 31, 300, 31);
        pdf.html(target, {
          html2canvas: {
              width: 50,
              scale:"0.178"
          },
          callback: function (doc) {
            doc.setPage(doc.internal.getNumberOfPages());
            doc.setFontSize(8);
            doc.setTextColor(130, 137, 151);
            doc.text(footer, 3, 287, {align: 'left'});
            doc.save(`${filename}.pdf`);
          },
          x: 3,
          y: 35
      });
  } else if (pageType === "multiCanvas") {
    html2canvas(htmlNode).then(function (canvas) {
      const imgWidth = 208;
      var pageHeight = 400;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      var heightLeft = imgHeight;
      var imgData = canvas.toDataURL("image/jpeg", 0.3);
      var pdf = new jsPDF(orientation, "mm", "a4", true);
      pdf.setFontSize(14);
      pdf.setTextColor(0, 0, 0);
      var img = new Image();
      // college icon
      img.src = `${croppedLogo}`;
      pdf.addImage(img, "JPEG", 5, 5, 15, 15);
      // header just right to the logo
      pdf.text(22, 14, header);
      pdf.setFontSize(10);
      pdf.text(5, 28, title);
      pdf.line(0, 31, 300, 31);
      var position = 35;
      // main node
      pdf.addImage(
        imgData,
        "JPEG",
        3,
        position,
        imgWidth - 3,
        imgHeight - 65,
        undefined,
        "FAST"
      );
      heightLeft -= pageHeight;
      while (heightLeft + 400 >= 0) {
        position += heightLeft - imgHeight; // top padding for other pages
        pdf.addPage();
        pdf.addImage(
          imgData,
          "JPEG",
          3,
          position,
          imgWidth - 3,
          imgHeight + 150,
          undefined,
          "FAST"
        );
        heightLeft -= pageHeight + 60;
      }
      pdf.line(0, 300 + 40, 300, 300 + 40);
      pdf.setFontSize(8);
      pdf.setTextColor(130, 137, 151);
      // footer after htmlNode
      pdf.text(5, pageHeight + 47, footer);
      // filename
      pdf.save(`${filename}.pdf`);
    });
  }
};
